<template>
  <v-row>
    <v-col cols="12" class="pt-0">
      <PageTitle title="Вакантные места"/>
    </v-col>

    <v-col cols="12" class="py-0">
      <v-btn
        small
        outlined
        rounded
        color="primary"
        class="white--text px-4 mr-2"
        @click="dialog = true"
      >
        <v-icon left small>mdi-plus</v-icon>Добавить
      </v-btn>

      <v-btn
        small
        outlined
        rounded
        :loading="uploadExcel"
        color="primary"
        class="white--text px-4 mr-2"
        @click="chooseExcelFile"
      >
        <input
          type="file"
          class="upload-excel-input"
          accept=".xls, .xlsx"
          ref="excelInput"
          @change="uploadFromExcel"
        />
        <v-icon left small>mdi-table-arrow-down</v-icon>
        Загрузить из EXCEL
      </v-btn>

      <v-btn
        small
        outlined
        rounded
        color="primary"
        :loading="downloadExcel"
        class="white--text px-4 mr-2"
        @click="downloadFromExcel"
      >
        <v-icon left small>mdi-table-arrow-up</v-icon>
        Сохранить в EXCEL
      </v-btn>
    </v-col>

    <v-col cols="12">
      <PageTable
        :table-loading="tableLoading"
        :table-headers="tableHeaders"
        filter
        :table-items="vacancyParent.list"
      >
        <template v-slot:button>
          <v-badge
            overlap
            dot
            :value="!!checkFilterProperties(vacancyFilter)"
          >
            <v-btn
              small
              rounded
              outlined
              color="primary"
              class="white--text ml-4 filter-btn"
              @click="showFilter = !showFilter"
            >
              <v-icon left small>mdi-filter-outline</v-icon>
              <span>{{ showFilter ? 'Закрыть' : 'Фильтр' }}</span>
            </v-btn>
          </v-badge>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon color="lightGrey" class="mr-1 edit-btn" size="22" title="Редактировать" @click="edit(item)">
            mdi-pencil-outline
          </v-icon>
          <v-icon color="lightGrey" class="remove-btn" size="22" title="Удалить" @click="remove(item)">
            mdi-trash-can-outline
          </v-icon>
        </template>
      </PageTable>
    </v-col>

    <transition name="curator-filter">
      <VacancyFilterComponent
        v-show="showFilter"
        @applyFilter="applyFilter"
        @closeFilter="showFilter = false"
        :filter="vacancyFilter"
        width-filter="300"
        top="255"
        right="29"
      />
    </transition>

    <VacanciesDialog
      :dialog="dialog"
      :saveBtnLoading="btnLoading"
      :selectedItem="selectedItem"
      @saveVacancy="saveVacancy"
      @closeModal="closeDialog"
    />

    <ConfirmDialog
      :dialog="confirmDialog"
      :loading="btnLoading"
      :message="`Вы уверены, что хотите удалить значение из справочника?`"
      @confirm="removeVacancy"
      @closeModal="closeDialog"
    />
  </v-row>
</template>

<script>
import {vacancyApi, excelApi} from '@/api'
import PageTitle from '@/components/ui/Title'
import PageTable from '@/components/ui/Table'
import {VacancyParent, VacancyFilter} from '@/models'
import VacancyFilterComponent from '@/components/zvp/vacancies/VacancyFilter'
import VacanciesDialog from '@/components/zvp/vacancies/dialogs/Vacancy'
import ConfirmDialog from '@/components/dialogs/ConfirmDelete'
import {mapGetters, mapState} from "vuex";
import _ from "lodash";
import download from "@/plugins/download";

export default {
  name: 'Vacancies',

  components: {
    PageTitle,
    VacanciesDialog,
    ConfirmDialog,
    PageTable,
    VacancyFilterComponent
  },

  created() {
    if (!this.checkRoles) this.$router.push('/')
  },

  data: () => ({
    tableHeaders: [
      { text: 'Номер курса', value: 'courseNumber.name', sortable: false, align: 'start' },
      { text: 'Специальность', value: 'speciality.name', sortable: false, align: 'start' },
      { text: 'Тип обучения', value: 'paidForm.name', sortable: false, align: 'start' },
      { text: 'Места', value: 'quantity', sortable: false, align: 'start'},
      { text: 'Действия', value: 'actions', sortable: false, align: 'center', width: '100px' },
    ],
    vacancyParent: new VacancyParent(),
    vacancyFilter: new VacancyFilter(),
    selectedItem: null,

    tableLoading: false,
    btnLoading: false,
    uploadExcel: false,
    downloadExcel: false,

    confirmDialog: false,
    dialog: false,
    showFilter: false,

    pageNumber: 0,
    lastPage: false,
  }),

  computed: {
    ...mapState('system', ['dataLoaded']),
    ...mapGetters('user', ['isCurator', 'isAdmin']),

    checkRoles() {
      return this.isCurator || this.isAdmin
    },
  },

  methods: {
    chooseExcelFile() {
      this.$refs.excelInput.value = ''
      this.$refs.excelInput.dispatchEvent(new MouseEvent('click'))
    },

    async uploadFromExcel() {
      try {
        this.uploadExcel = true
        await excelApi.exportXlsxVacancy(this.$refs.excelInput.files[0])
        await this.applyFilter()
        this.$toastr('success', '', 'Успешно сохранено')
      } catch (e) {
        this.$toastr('error', 'Ошибка загрузки файла')
      } finally {
        this.uploadExcel = false
      }
    },

    async downloadFromExcel() {
      try {
        this.downloadExcel = true
        const data = await excelApi.importXlsxVacancy()
        data && download(data, `Вакантные_места.xlsx`)
      } catch (e) {
        this.showErrorMessage(e)
      } finally {
        this.downloadExcel = false
      }
    },

    checkFilterProperties(applicationsFilter) {
      for(let item in applicationsFilter) {
        if (applicationsFilter[item]?.id) return true
      }
    },

    async applyFilter(item = null) {
      this.vacancyFilter = item ? item : new VacancyFilter()
      this.vacancyParent.list = []
      this.lastPage = false
      this.pageNumber = 0
      await this.getVacancies()
    },

    async getVacancies() {
      this.tableLoading = true
      try {
        if (!this.lastPage) {
          const {last, content} = await vacancyApi.findAllByFilter(this.pageNumber, this.vacancyFilter)
          content?.length && this.vacancyParent.build(content)
          this.lastPage = last
          this.pageNumber++
        }
      } catch (e) {
        this.showErrorMessage(e)
      } finally {
        this.tableLoading = false
      }
    },

    async saveVacancy(body) {
      try {
        this.btnLoading = true

        const data = body.id ? await vacancyApi.update(body) : await vacancyApi.create(body)
        body.id ? this.vacancyParent.update(data) : this.vacancyParent.add(data)

        this.$toastr('success', '', 'Успешно сохранено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e)
      } finally {
        this.btnLoading = false
      }
    },

    async removeVacancy() {
      try {
        this.btnLoading = true

        await vacancyApi.remove(this.selectedItem.id)
        this.vacancyParent.removeVacancy(this.selectedItem)
        this.$toastr('success', '', 'Успешно удалено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e)
      } finally {
        this.btnLoading = false
      }
    },

    edit(item) {
      this.selectedItem = item
      this.dialog = true
    },

    remove(item) {
      this.selectedItem = item
      this.confirmDialog = true
    },

    closeDialog() {
      this.dialog = false
      this.confirmDialog = false
      this.selectedItem = null
    },
  },

  watch: {
    dataLoaded: {
      immediate: true,
      async handler(value) {
        if (value) {
          await this.getVacancies()
        }
      }
    },

    dialog: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.showFilter = false
        }
      }
    },

    confirmDialog: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.showFilter = false
        }
      }
    }
  },
}
</script>

<style scoped>

.curator-filter-enter-active {
  transition: opacity .2s;
}

.curator-filter-leave-active {
  transition: opacity .2s;
}

.curator-filter-enter, .curator-filter-leave-to {
  opacity: 0;
}

.filter-btn {
  width: 150px;
}

.filter-btn span {
  width: 70px;
}

.upload-excel-input {
  display: none;
}
</style>
